export enum Routes {
  LOGIN = "/auth/login",
  COURSES = "/my-courses",
  MONITORING = "/monitoring",
  BUSINESS_PLAN = "/business-plan",
  PROFILE = "/profile",
  START = "/course",
  NO_ACCESS = "/no-access",
}
